// extracted by mini-css-extract-plugin
module.exports = {"Ad":"GoogleAd_Ad__rugL0","card":"GoogleAd_card__ruBxU"};